import { render, staticRenderFns } from "./loginNew.vue?vue&type=template&id=37e932a6&scoped=true"
import script from "./loginNew.vue?vue&type=script&lang=js"
export * from "./loginNew.vue?vue&type=script&lang=js"
import style0 from "./loginNew.vue?vue&type=style&index=0&id=37e932a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e932a6",
  null
  
)

export default component.exports